import classes from './dateRangeCalendar.module.css';
import { DateRange } from 'react-date-range';

function DateRangeCalendar({
  value = [
    {
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection'
    }
  ],
  setValue,
  disabledDates,
  children = <></>,
  ...props
}) {
  return (
    <div className={classes.main}>
      {/* <style>{`
       .rdrDateDisplayWrapper {
        display: block !important;
      }
        .rs-picker-default .rs-picker-toggle {
        background-color:"red";
        }
      .rdrStartEdge {
        color: #0080ff70 !important;
        border-left:1px solid blue;
        border-radius:0px;
      }
      .rdrDay:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span, .rdrDay:not(.rdrDayPassive) .rdrStartEdge ~ .rdrDayNumber span, .rdrDay:not(.rdrDayPassive) .rdrEndEdge ~ .rdrDayNumber span, .rdrDay:not(.rdrDayPassive) .rdrSelected ~ .rdrDayNumber span{
        color:var(--text-black-clr);
        font-weight:500;
      }
      .rdrEndEdge {
        color: #0080ff70 !important;
        border-radius:0;
        border-right:1px solid blue;
      }
      .rdrInRange {
        background: #0080ff70 !important;
        color: color:var(--text-black-clr) !important;
      }
      .rdrDayNumber {
        color: color:var(--text-black-clr) !important;
      }
      .rdrMonthAndYearWrapper {
        width: 100% !important;
      }
      .rdrMonth {
        width: 100%;
      }
      .rdrCalendarWrapper {
        width: 100% !important;
      }
      
      `}</style> */}
      <DateRange
        editableDateInputs={true}
        selected={new Date()}
        onChange={(item) => {
          setValue([item.selection]);
        }}
        moveRangeOnFirstSelection={false}
        showDateDisplay={false}
        ranges={value}
        disabledDates={disabledDates}
        retainEndDateOnFirstSelection={true}
        {...props}
      />
      {children}
    </div>
  );
}

export default DateRangeCalendar;
